/**
 * 获取最新用户权限信息
 **/ 

// import Vue from "vue"
// const app = Vue.prototype;

import request from "./request"

export function getUserInfo() {
    return new Promise((resolve,reject) => {
        request.post({url:"/corporate/getUserInfo"}).then(res => {
            localStorage.userInfo = JSON.stringify(res.data);

            resolve(res);
        })
    })
}


// WEBPACK FOOTER //
// ./src/libs/api/getUserInfo.js